module.exports = __webpack_public_path__ + "img/brand_popup_bg02_t.0528b36.48e1b358.png";